module.exports = __webpack_public_path__ + "static/media/tekura2.fd209e7f.jpg";